const BlogApi = [
  {
    id: 1,
    image: 'https://miro.medium.com/max/1100/1*mor1L4FMxAC90eEDGZWCwQ.jpeg',
    date: '1 May, 2022',
    title_one: 'Randomized-string Node module package',
    desc_one: 'This is a node module package project I did together with my friend last month. The package is called randomized-string which Generates Random strings based on passed parameters. The best scenario is for this project to be used is for:',
    title_two: '',
    desc_two: '1. Password generation 2. Token generation.3.Testing 4. id generation 5.Random Unicode Emoji Generator.',
    desc_three: 'We have many different features on this package to give developers the flexibility so that we will generate based on the needs of the programmer. we will discuss more on the features in detail later.We used Typescript and JavaScript to build the packageTypeScript is a strongly typed programming language that builds on JavaScript, giving you better tooling at any scale.',
    link: 'https://medium.com/@sentayhu19/randomized-string-node-module-package-901cfe491b55',
  },
  {
    id: 2,
    image: 'https://miro.medium.com/max/1100/1*z1FM4IvyhUwG1UVNeFkZiQ.jpeg',
    date: '15 May, 2022',
    title_one: 'Modern Cryptography ',
    desc_one: 'Hello, everyone, We will be discussing modern cryptography in general.So Cryptography can be defined as the process of concealing the contents of a message from all except those who know the key during its transit or storage. Modern cryptosystems utilize computationally complex algorithms and long cryptographic keys to meet the Cryptographic Goals of confidentiality, integrity, authentication, and nonrepudiation.',
    title_two: '',
    desc_two: '',
    title_three: '',
    desc_three: '',
    link: 'https://medium.com/@sentayhu19/modern-cryptography-a856671fc381',
  },
];
export default BlogApi;
